import React from 'react';
import { BackupConfigProps } from './types';

interface StorageDriverSelectorProps {
  config: BackupConfigProps['config'];
  onConfigChange: BackupConfigProps['onConfigChange'];
  onOpenGithubConnect: () => void;
}

const StorageDriverSelector: React.FC<StorageDriverSelectorProps> = ({
  config,
  onConfigChange,
  onOpenGithubConnect,
}) => {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
        Storage Driver
      </label>
      <div className="flex items-center gap-2">
        <select
          value={config.driver}
          onChange={(e) => onConfigChange({ ...config, driver: e.target.value as any })}
          className="flex-1 px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {import.meta.env.MODE !== 'production' && (
            <option value="local">Local (dev only)</option>
          )}
          <option value="s3">S3-compatible</option>
          <option value="github">GitHub Repository</option>
          <option value="sftp">SFTP</option>
        </select>
        {config.driver === 'github' && (
          <button
            type="button"
            onClick={onOpenGithubConnect}
            className="px-3 py-2 bg-slate-900 text-white rounded"
          >
            Connect GitHub
          </button>
        )}
      </div>
    </div>
  );
};

export default StorageDriverSelector;